import styled from "styled-components";
import { Button as ButtonPrimitive } from "@sonder/ui/source/styled/primitives/Button";
import {
  SchedulerColors,
  SchedulerShadows,
  borders,
} from "@sonder/ui/source/styled/theme";

export const CheckInCheckOutBlock = styled.div`
  background: #f3f3f3;
  border: ${borders.standard};
  border-radius: 0.3rem;
`;

export type RelatedTasksStatus =
  | "archived"
  | "canceled"
  | "complete"
  | "inprogress"
  | "late"
  | "ready"
  | "unassigned";

export interface RelatedTasksBlockProps {
  isOpen?: boolean;
  isSelected?: boolean;
  isSelecting?: boolean;
  status: RelatedTasksStatus;
}

// Comma inserted at the front to minimize impact to the already near unreadable line here. We have a 1-3 box shadows.
const relatedTaskOpenShadow =
  ", 0 4px 8px rgba(21, 22, 25, 0.2), 0 10px 16px rgba(21, 22, 25, 0.24)";

export const RelatedTaskBlock = styled(ButtonPrimitive)<RelatedTasksBlockProps>`
  align-items: center;
  background: ${props => SchedulerColors[props.status]};
  background-size: 56.57px 56.57px;
  border-radius: 0.3rem;
  box-shadow: inset 0 -0.25rem 0 ${props =>
      SchedulerShadows[props.status]}${props =>
      props.isOpen ? relatedTaskOpenShadow : ""};
  display: flex;
  justify-content: flex-start;
  opacity: ${props => props.isSelecting && (props.isSelected ? 1 : 0.5)};
  padding: 0.5rem;

  &:hover {
    opacity: ${props => props.isSelecting && (props.isSelected ? 1 : 0.75)};
  }
`;

export const StackedSchedules = styled.div`
  min-height: 3.14rem;
  position: relative;
  width: 100%;

  .react-grid-layout {
    position: absolute;
  }
`;

export const ScheduleBounds = styled.div`
  border: ${borders.standard};
  border-top: 0;
  border-bottom: 0;
  box-sizing: border-box;
  cursor: pointer;
  height: 100%;
  position: absolute;
  pointer-events: none;
  transition: background 100ms linear, opacity 100ms linear;
  width: 100%;
`;

export const ScheduleBoundingParent = styled.div`
  height: 100%;
  overflow: hidden;
  position: absolute;
  pointer-events: none;
  width: 100%;
`;
